export default "__VITE_ASSET__ouIjsMz2__"